// eslint-disable-next-line import/no-cycle
import HttpClient from './http';

export const getClass = async () => {
  try {
    const resp = await HttpClient.get('class');

    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const getClassById = async (id) => {
  try {
    const resp = await HttpClient.get(`class/${id}`);

    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const createClass = async (data) => {
  try {
    const resp = await HttpClient.post('class/new-class', {
      ...data,
      year: data.year.toString(),
    });
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const editClass = async (data) => {
  try {
    const resp = await HttpClient.put('class/update', {
      ...data,
      year: data.year.toString(),
    });
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const removeClass = async (data) => {
  try {
    const resp = await HttpClient.delete('class/delete', { params: data });
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const createUserClass = async (data) => {
  try {
    const resp = await HttpClient.post('user-class/new-user-class', data);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const deleteUserClass = async (data) => {
  try {
    const resp = await HttpClient.delete('user-class/delete-user-class', {
      params: data,
    });
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};
